/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Print_Printbutton1Inputs */

const zh_print_printbutton1 = /** @type {(inputs: Print_Printbutton1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打印`)
};

const en_print_printbutton1 = /** @type {(inputs: Print_Printbutton1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Print`)
};

const es_print_printbutton1 = /** @type {(inputs: Print_Printbutton1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imprimir`)
};

/**
* | output |
* | --- |
* | "Print" |
*
* @param {Print_Printbutton1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const print_printbutton1 = /** @type {((inputs?: Print_Printbutton1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Print_Printbutton1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_print_printbutton1(inputs)
	if (locale === "en") return en_print_printbutton1(inputs)
	return es_print_printbutton1(inputs)
});
export { print_printbutton1 as "print_printButton" }